import * as con from "../Constants"
import { isServerAlive } from "../utils/apiFunctions"
import { setStoredValue } from "./actions"


export const checkServer = async () => {

    setStoredValue(con.SERVER_STATUS, con.STATUS_PROCESSING)

    const isAlive = await isServerAlive()

    if (isAlive)
        setStoredValue(con.SERVER_STATUS, con.STATUS_OK)
    else
        setStoredValue(con.SERVER_STATUS, con.STATUS_ERROR)



}